export const DetailedCardIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="16" height="7.5" rx="1" fill="#797979" />
      <rect x="1" y="9.5" width="16" height="7.5" rx="1" fill="#797979" />
    </svg>
  );
};
export const MinimumCardIcon = () => {
  return (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1.6665" y="0.950001" width="7.5" height="4.7" rx="1" fill="#797979" />
      <rect x="1.6665" y="6.65" width="7.5" height="4.7" rx="1" fill="#797979" />
      <rect x="1.6665" y="12.35" width="7.5" height="4.7" rx="1" fill="#797979" />
      <rect x="10.1665" y="0.950001" width="7.5" height="4.7" rx="1" fill="#797979" />
      <rect x="10.1665" y="6.65" width="7.5" height="4.7" rx="1" fill="#797979" />
      <rect x="10.1665" y="12.35" width="7.5" height="4.7" rx="1" fill="#797979" />
    </svg>
  );
};
export const CompactCardIcon = () => {
  return (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1.33325" y="0.950001" width="7.5" height="7.55" rx="1" fill="#797979" />
      <rect x="1.33325" y="9.5" width="7.5" height="7.55" rx="1" fill="#797979" />
      <rect x="9.83325" y="0.950001" width="7.5" height="7.55" rx="1" fill="#797979" />
      <rect x="9.83325" y="9.5" width="7.5" height="7.55" rx="1" fill="#797979" />
    </svg>
  );
};
export const MicroCardIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 1.94554C3 1.69948 3.18934 1.5 3.42291 1.5H6.25709C6.49066 1.5 6.68 1.69948 6.68 1.94554V4.29372C6.68 4.53979 6.49066 4.73926 6.25709 4.73926H3.42291C3.18934 4.73926 3 4.53979 3 4.29372V1.94554Z"
        fill="#797979"
      />
      <path
        d="M3 5.8658C3 5.61973 3.18934 5.42025 3.42291 5.42025H6.25709C6.49066 5.42025 6.68 5.61973 6.68 5.8658V8.21397C6.68 8.46004 6.49066 8.65952 6.25709 8.65952H3.42291C3.18934 8.65952 3 8.46004 3 8.21397V5.8658Z"
        fill="#797979"
      />
      <path
        d="M3 9.78604C3 9.53997 3.18934 9.34049 3.42291 9.34049H6.25709C6.49066 9.34049 6.68 9.53997 6.68 9.78604V12.1342C6.68 12.3803 6.49066 12.5798 6.25709 12.5798H3.42291C3.18934 12.5798 3 12.3803 3 12.1342V9.78604Z"
        fill="#797979"
      />
      <path
        d="M3 13.7063C3 13.4602 3.18934 13.2607 3.42291 13.2607H6.25709C6.49066 13.2607 6.68 13.4602 6.68 13.7063V16.0545C6.68 16.3005 6.49066 16.5 6.25709 16.5H3.42291C3.18934 16.5 3 16.3005 3 16.0545V13.7063Z"
        fill="#797979"
      />
      <path
        d="M7.15999 1.94554C7.15999 1.69948 7.34933 1.5 7.5829 1.5H10.4171C10.6507 1.5 10.84 1.69948 10.84 1.94554V4.29372C10.84 4.53979 10.6506 4.73926 10.4171 4.73926H7.5829C7.34933 4.73926 7.15999 4.53979 7.15999 4.29372V1.94554Z"
        fill="#797979"
      />
      <path
        d="M7.15999 5.8658C7.15999 5.61973 7.34933 5.42025 7.5829 5.42025H10.4171C10.6507 5.42025 10.84 5.61973 10.84 5.8658V8.21397C10.84 8.46004 10.6506 8.65952 10.4171 8.65952H7.5829C7.34933 8.65952 7.15999 8.46004 7.15999 8.21397V5.8658Z"
        fill="#797979"
      />
      <path
        d="M7.15999 9.78604C7.15999 9.53997 7.34933 9.34049 7.5829 9.34049H10.4171C10.6507 9.34049 10.84 9.53997 10.84 9.78604V12.1342C10.84 12.3803 10.6506 12.5798 10.4171 12.5798H7.5829C7.34933 12.5798 7.15999 12.3803 7.15999 12.1342V9.78604Z"
        fill="#797979"
      />
      <path
        d="M7.15999 13.7063C7.15999 13.4602 7.34933 13.2607 7.5829 13.2607H10.4171C10.6507 13.2607 10.84 13.4602 10.84 13.7063V16.0545C10.84 16.3005 10.6506 16.5 10.4171 16.5H7.5829C7.34933 16.5 7.15999 16.3005 7.15999 16.0545V13.7063Z"
        fill="#797979"
      />
      <path
        d="M11.32 1.94554C11.32 1.69948 11.5093 1.5 11.7429 1.5H14.5771C14.8107 1.5 15 1.69948 15 1.94554V4.29372C15 4.53979 14.8107 4.73926 14.5771 4.73926H11.7429C11.5093 4.73926 11.32 4.53979 11.32 4.29372V1.94554Z"
        fill="#797979"
      />
      <path
        d="M11.32 5.8658C11.32 5.61973 11.5093 5.42025 11.7429 5.42025H14.5771C14.8107 5.42025 15 5.61973 15 5.8658V8.21397C15 8.46004 14.8107 8.65952 14.5771 8.65952H11.7429C11.5093 8.65952 11.32 8.46004 11.32 8.21397V5.8658Z"
        fill="#797979"
      />
      <path
        d="M11.32 9.78604C11.32 9.53997 11.5093 9.34049 11.7429 9.34049H14.5771C14.8107 9.34049 15 9.53997 15 9.78604V12.1342C15 12.3803 14.8107 12.5798 14.5771 12.5798H11.7429C11.5093 12.5798 11.32 12.3803 11.32 12.1342V9.78604Z"
        fill="#797979"
      />
      <path
        d="M11.32 13.7063C11.32 13.4602 11.5093 13.2607 11.7429 13.2607H14.5771C14.8107 13.2607 15 13.4602 15 13.7063V16.0545C15 16.3005 14.8107 16.5 14.5771 16.5H11.7429C11.5093 16.5 11.32 16.3005 11.32 16.0545V13.7063Z"
        fill="#797979"
      />
    </svg>
  );
};
